import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Requests.css';

function Requests() {
  const [requests, setRequests] = useState([]);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      navigate('/admin');
      return;
    }
    fetch('/api/requests', {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        if (data.requests) setRequests(data.requests);
        else setMessage(data.message || 'Ошибка загрузки заявок');
      })
      .catch(err => {
        console.error(err);
        setMessage('Ошибка загрузки заявок');
      });
  }, [navigate]);

  return (
    <div className="requests-container">
      <h1 className="requests-title">Список заявок</h1>
      {message && <p className="error-message">{message}</p>}
      <ul className="requests-list">
        {requests.map(req => (
          <li key={req.id} className="request-item">
            <p><strong>Имя:</strong> {req.name}</p>
            <p><strong>Телефон:</strong> {req.phone}</p>
            <p><strong>Дата:</strong> {new Date(req.created_at).toLocaleString()}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Requests;
